import EmptyState from '@/components/EmptyState';
import { useT } from '@/i18n';
import { Block, Navbar, Page } from 'framework7-react';

// Placeholder shell for the upcoming Customer Service area. Wired into the
// sidebar/routes now; the actual tooling lands in a follow-up.
function CustomerServicePage() {
  const t = useT();
  return (
    <Page name="customer-service">
      <Navbar title={t.nav.customerService} />
      <Block>
        <EmptyState
          icon="bubble_left_bubble_right_fill"
          iconColor="#0ea5e9"
          title={t.nav.customerService}
          description="This area is coming soon."
        />
      </Block>
    </Page>
  );
}

export default CustomerServicePage;
